/**
 * TVModePage - Full-screen bin dashboard for warehouse TV displays
 *
 * Renders the normal BinDashboardPage without app chrome (no sidebar, no header).
 * Escape key or the exit button returns to the standard dashboard.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BinDashboardPage } from './BinDashboardPage';

export function TVModePage() {
  const { t } = useTranslation('production');
  const navigate = useNavigate();

  // Escape key to exit TV mode
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        navigate('/production/bins');
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Exit button - fixed top-right */}
      <Button
        variant="ghost"
        size="icon"
        className="fixed top-3 right-3 z-50 opacity-40 hover:opacity-100 transition-opacity"
        onClick={() => navigate('/production/bins')}
        title={t('bins.exitTvMode')}
      >
        <X className="h-5 w-5" />
      </Button>

      <BinDashboardPage />
    </div>
  );
}
